module.exports = __webpack_public_path__ + "media/app/fonts/catamaran-v4-latin-700-66bf43dd28d4d9827d9548fcd1a915a1.ttf";